









import Vue from 'vue'

export default Vue.extend({
  name: 'AdminMenu',
  data() {
    return {
      restaurantId: this.$route.params.restaurantId,
    }
  },
})
